export enum Status {
  LIVE = 'LIVE',
  VENDUTO = 'VENDUTO',
  PROPOSTA = 'PROPOSTA',
}
